"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SliderControls(_ref) {
  var _this = this;

  var slides = _ref.slides;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "slider-controls"
  }, slides.map(function (image, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "control",
      key: i,
      onClick: function onClick() {
        return _this.props.handleClick(i);
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: i,
      src: image
    }));
  }));
}

SliderControls.propTypes = {
  slides: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = SliderControls;
exports.default = _default;